import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref } from 'vue'
import CIcon from '../c-icon/c-icon.component.vue'
import { CIconFactory } from '../c-icon'
import { getJapaneseLanguageListStore } from '../../../../../core/src/store/japanese-language-list.store'
import { IJapaneseConversation, LocalizationData, LocalizationPath } from '../../../../../../core/src'
import { JapaneseConversationGetters } from '../../../../../../core/src/domain/japanese-language/japanese-conversation.getters'
import { LocalizationService } from '../../../../../core/src/modules/language/localization-service'
import { getLocalization } from '../../helper/c-translation-helper'
import { ValidationProvider } from 'vee-validate'

export default /*#__PURE__*/_defineComponent({
  __name: 'c-jp-level.component',
  props: {
  value: {
    type: Number,
    required: false
  },
  App: {
    required: true,
    type: Object as PropType<any>
  }
},
  emits: ['click'],
  setup(__props, { emit }) {

const props = __props;



const jpStore = getJapaneseLanguageListStore()
const jpList = jpStore.values()
const App = props.App
const localization: LocalizationData = getLocalization(App)
const selectedLevel = ref<number | undefined>(props.value || undefined)
const interviewText = LocalizationService.t<string>(localization, LocalizationPath.CJPLevelInterviewText)

const selectJPLevel = (id: number | undefined) => {
  selectedLevel.value = id!
  emit('click', id)
}

const calculateScale = (index: number) => {
  const baseScale = 0.08 + index * 0.23
  return selectedLevel.value === jpList[index].id ? baseScale + 0.06 : baseScale
}

function getName(JPLevel: IJapaneseConversation) {
  return JapaneseConversationGetters.getLabel(JPLevel)
}

function getDescription(JPLevel: IJapaneseConversation) {
  return JapaneseConversationGetters.getDescription(JPLevel)
}

// Function to calculate the color for each .trappy div, changing to theme-blue-dark1-color if selected
const calculateColor = (index: number) => {
  // if there is currently no selected level, return the default color
  if (!selectedLevel.value) {
    return 'background-blue-light1'
  }
  // if the current level is selected, return the selected color
  return selectedLevel.value === jpList[index].id ? 'background-blue-light1' : 'background-shades-medium2'
}

const unselectedIcon = CIconFactory.CircleRegular()
const selectedIcon = CIconFactory.CircleCheckMd()

return { __sfc: true,props, emit, jpStore, jpList, App, localization, selectedLevel, interviewText, selectJPLevel, calculateScale, getName, getDescription, calculateColor, unselectedIcon, selectedIcon, CIcon, ValidationProvider }
}

})